import React from 'react';
import { withProps } from 'recompose';

import { InfoWindow } from 'components/core/GoogleMap';
import { NewFacilityCard } from 'components/facility/FacilityCard';

export const enhance = withProps(
	({
		actions,
		facility,
		baseUrl,
		facilitySelected,
		handleFacilityCardVisible,
		handleFacilitySelected,
		handleFacilityDeselected,
		handlePinDeselected,
		location,
		searchType,
		searchParams,
	}) => ({
		location: facility.location,
		content: (
			<NewFacilityCard // here for the desktop version
				facility={facility}
				baseUrl={baseUrl}
				facilitySelected={facilitySelected}
				getFacilityCardPhoneNumber={() =>
					actions.getFacilityCardPhoneNumber(
						location.city,
						location.state,
						facility.id,
					)
				}
				handleFacilitySelected={handleFacilitySelected}
				handleFacilityDeselected={handleFacilityDeselected}
				handlePinDeselected={handlePinDeselected}
				miniCard
				onVisible={handleFacilityCardVisible}
				storageType={searchType}
				searchParams={searchParams}
			/>
		),
	}),
);

export default enhance(InfoWindow);
